import React from "react";
import { Container } from "react-bootstrap";
import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";  
import "./Footer.css";

function Footer() {
  const { i18n } = useTranslation();  
  const isEnglish = i18n.language === "en";  
  const year = new Date().getFullYear();  

  const socialLinks = [
    { 
      name: "Email", 
      icon: <AiOutlineMail />, 
      link: "mailto:redamdair@outlook.com",
      label: isEnglish ? "Send an email to Reda" : "Envoyer un email à Reda"
    },
    { 
      name: "LinkedIn", 
      icon: <FaLinkedinIn />, 
      link: isEnglish ? "https://www.linkedin.com/in/redamdair/?locale=en_US" : "https://www.linkedin.com/in/redamdair",
      label: isEnglish ? "Visit LinkedIn profile" : "Visiter le profil LinkedIn"
    },
    { 
      name: "GitHub", 
      icon: <AiFillGithub />, 
      link: "https://github.com/rmdair",
      label: isEnglish ? "Visit GitHub profile" : "Voir le profil GitHub"
    }
  ];

  return (
    <Container as="footer" fluid className="footer d-flex flex-column align-items-center justify-content-center">
      {/* Réseaux sociaux - Utilisation de nav pour l'accessibilité */}
      <nav className="reseaux-container" aria-label={isEnglish ? "Social Media Links" : "Liens réseaux sociaux"}>
        {socialLinks.map((item, i) => (
          <div key={i} className="reseaux-item">
            <span className="name-reseaux" aria-hidden="true">{item.name}</span>
            <a 
              href={item.link} 
              target="_blank" 
              rel="noreferrer" 
              className="footer-icon"
              aria-label={item.label} // Correction pour le score 100 Accessibilité
            >
              {item.icon}
            </a>
          </div>
        ))}
      </nav>

      {/* Ligne de séparation */}
      <div className="ligne" aria-hidden="true"></div>

      {/* Motto + Copyright */}
      <div className="footer-text">
        <p className="copyright">
          Copyright © {year} Reda Mdair. {isEnglish ? "All rights reserved." : "Tous droits réservés."}
        </p>
      </div>
    </Container>
  );
}

export default Footer;